





























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// import { State, Action, Getter } from 'vuex-class';
import VueApexCharts from "vue-apexcharts";
import thinBar from "@/data/thin-bar-graph";
import thinDonutGender from "@/data/thin-donut-gender-chart";

@Component({
  components: {
    VueApexCharts,
  },
})
export default class GenderRatioChart extends Vue {
  thinDonut: any = thinDonutGender;
  seriesData!: any;
  optionsData!: any;

  mounted() {
    this.loadContent();
  }

  async loadContent() {
    this.seriesData = [70, 50];
  }

  get lineSeriesData() {
    return this.seriesData || this.thinDonut.series;
  }

  get lineOptionsData() {
    return this.optionsData || this.thinDonut.options;
  }
}
